// Kort för en skyddsrond i mappträdet – samma plats som övriga dokument.
import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { HardHat, FolderOpen, ArrowRight } from "lucide-react";

export interface SafetyRoundCardData {
  id: string;
  name: string;
  round_date: string | null;
  status: string | null;
  project_id: string;
  folder_id: string | null;
}

interface Props {
  round: SafetyRoundCardData;
  folderName?: string | null;
  onOpenFolder?: () => void;
}

const STATUS_LABEL: Record<string, string> = {
  draft: "Utkast",
  signed: "Genomförd",
};

export const ModernSafetyRoundCard: React.FC<Props> = ({ round, folderName, onOpenFolder }) => {
  const navigate = useNavigate();

  return (
    <Card className="h-full transition-shadow hover:shadow-md">
      <CardContent className="space-y-3 p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <HardHat className="h-4 w-4 text-primary" />
              <span className="truncate font-medium">{round.name}</span>
            </div>
            <p className="mt-1 text-sm text-muted-foreground">
              Dok 27 · Skyddsrondsprotokoll
              {round.round_date ? ` · ${round.round_date}` : ""}
            </p>
          </div>
          <Badge variant={round.status === "signed" ? "default" : "secondary"} className="text-[10px]">
            {STATUS_LABEL[round.status ?? "draft"] ?? "Utkast"}
          </Badge>
        </div>

        {folderName && (
          <button
            type="button"
            onClick={onOpenFolder}
            className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
          >
            <FolderOpen className="h-3 w-3" />
            {folderName}
          </button>
        )}

        <Button
          size="sm"
          variant="outline"
          className="w-full"
          onClick={() => navigate(`/dokument/skyddsrond/${round.project_id}`)}
        >
          Öppna skyddsronden <ArrowRight className="ml-1 h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
};

export default ModernSafetyRoundCard;
